module.exports = __webpack_public_path__ + "a666ff2f12ac91d78998ce4d39b18e90.jpg";